import { ReactElement } from "react";
import { infoToolTipCardOptions } from "../../../interfaces/infoToolTipCardOptions";
import { Tooltip } from "@mui/material";
import ToolTipCard from "../ToolTipCard/ToolTipCard";
import * as Styles from "./HoverToolTip.styles";

interface HoverToolTipPropsType {
  content: infoToolTipCardOptions | string;
  color?: string;
  backgroundColor?: string;
  children: ReactElement;
}

export default function HoverToolTip({ content, color, backgroundColor, children }: HoverToolTipPropsType) {
  const contentType = typeof content;

  function getChosenInfoToolTipDisplayLayout() {
    if (contentType === "object") {
      const cardContent = content as infoToolTipCardOptions;
      return (
        <ToolTipCard cardTitle={cardContent.cardTitle} cardSubtitle={cardContent.cardSubtitle} cardlistItems={cardContent.cardlistItems} />
      );
    }
    return content.toString();
  }
  const isCardContent = typeof content === "object";
  return (
    <Tooltip
      title={getChosenInfoToolTipDisplayLayout()}
      arrow
      placement="bottom"
      {...(isCardContent ? { slotProps: Styles.getToolTipStyle({ color, backgroundColor }) } : {})}
    >
      <Styles.TooltipWrapper>{children}</Styles.TooltipWrapper>
    </Tooltip>
  );
}
